import { Visibility } from "@mui/icons-material";
import { Box, Fab, Paper, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledMessaging = {
  ChatAreaContainer: styled(Box)(({ theme }) => ({
    width: "70%",
    display: "flex",
    flexDirection: "column",
  })),

  ChatAreaHeader: styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: `1px solid ${theme.palette.divider}`,
  })),

  ChatAreaContent: styled(Box)(({ theme }) => ({
    flex: 1,
    padding: theme.spacing(2),
    overflowY: "auto",
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  })),

  ChatMessageRow: styled(Box, {
    shouldForwardProp: (prop) => prop !== "isPrestador",
  })(({ theme, isPrestador }) => ({
    display: "flex",
    justifyContent: isPrestador ? "flex-end" : "flex-start",
    alignItems: "flex-start",
    gap: theme.spacing(1),
  })),

  AvatarPlaceholder: styled(Box, {
    shouldForwardProp: (prop) => prop !== "isPrestador",
  })(({ theme, isPrestador }) => ({
    width: 32,
    height: 32,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: isPrestador ? "#d0def7" : "#e0e0e0",
  })),

  MessageBubbleContainer: styled(Box, {
    shouldForwardProp: (prop) => prop !== "isPrestador",
  })(({ theme, isPrestador }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: isPrestador ? "flex-end" : "flex-start",
    maxWidth: "75%",
  })),

  MessageInfo: styled(Box)(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
    alignItems: "baseline",
    marginBottom: theme.spacing(0.5),
  })),

  MessageBubble: styled(Paper, {
    shouldForwardProp: (prop) => prop !== "isPrestador",
  })(({ theme, isPrestador }) => ({
    padding: theme.spacing(2),
    borderRadius: theme.spacing(2),
    backgroundColor: isPrestador ? "#e8effc" : "#f5f5f5",
    border: "1px solid",
    borderColor: isPrestador ? "#d0def7" : "#e0e0e0",
    borderTopRightRadius: isPrestador ? 0 : theme.spacing(2),
    borderTopLeftRadius: isPrestador ? theme.spacing(2) : 0,
    position: "relative",
    width: "100%",
  })),

  OriginalMessagePreview: styled(Box)(({ theme }) => ({
    marginBottom: theme.spacing(1),
    cursor: "pointer",
    opacity: 0.8,
    "&:hover": {
      opacity: 1,
    },
  })),

  InputAreaContainer: styled(Box)(({ theme }) => ({
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.paper,
    borderTop: `1px solid ${theme.palette.divider}`,
  })),

  InputAreaWrapper: styled(Box)(({ theme }) => ({
    border: "1px solid #d0def7",
    borderRadius: theme.shape.borderRadius,
    overflow: "hidden",
  })),

  ReplyToPreview: styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(1),
    backgroundColor: "#e8effc",
    borderBottom: "1px solid #d0def7",
  })),

  InputActionsWrapper: styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(1),
  })),

  MessageStatus: styled("span")(({ theme }) => ({
    marginLeft: 8,
    fontStyle: "italic",
  })),

  OriginalMessageText: styled(Typography)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  })),

  ContainerWrapper: styled("div")(({ theme }) => ({
  })),

  AccidentDisplayWrapper: styled("div", {
    shouldForwardProp: (prop) => prop !== "displayMode",
  })(({ theme, displayMode }) => ({
    display: displayMode,
  })),

  NewConversationFab: styled(Fab)(({ theme }) => ({
    position: "fixed",
    bottom: 32,
    right: 32,
  })),

  TableToolbarWrapper: styled(Box)(({ theme }) => ({
    margin: theme.spacing(0.5),
    display: "flex",
    justifyContent: "space-evenly",
  })),

  TableActionsWrapper: styled(Box)(({ theme }) => ({
    display: "flex",
    gap: "0.5rem",
    alignItems: "center",
  })),

  ClickableVisibilityIcon: styled(Visibility)(({ theme }) => ({
    cursor: "pointer",
  })),

  DetailPanelContainer: styled(Box)(({ theme }) => ({
    margin: "10px",
    padding: "10px",
    backgroundColor: "#f9f9f9",
    borderRadius: "5px",
  })),

  DetailMessageRow: styled(Box)(({ theme }) => ({
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid #ccc",
    padding: "5px 0",
  })),
};
